import script from "./AlertDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertDialog.vue?vue&type=script&setup=true&lang=ts"

import "./AlertDialog.vue?vue&type=style&index=0&id=625b0ba7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-625b0ba7"]])

export default __exports__